import {DataEditor, DataEditorProps, DataEditorRef} from "@glideapps/glide-data-grid";
import {forwardRef, useMemo} from "react";
import {ImageTextCellRenderer} from "./cells/ImageTextCell";
import {DispatchSeparatorCellRenderer} from "./cells/DispatchSeparatorCell";
import type {CustomRenderer} from "@glideapps/glide-data-grid/dist/ts/data-grid/cells/cell-types";
import {CustomCell} from "@glideapps/glide-data-grid/dist/ts/data-grid/data-grid-types";
import {allCells} from "@glideapps/glide-data-grid-cells";

export type DataGridProps = Omit<DataEditorProps, 'customRenderers'>;

export const DataGrid = forwardRef<DataEditorRef, DataGridProps>((props, ref) => {

  const _customRenderers : CustomRenderer<CustomCell<any>>[] = useMemo(() => {
    return [
      ImageTextCellRenderer,
      DispatchSeparatorCellRenderer,
      ...allCells,
    ]
  }, [])


  return (
    <DataEditor
      {...props}
      ref={ref}
      customRenderers={_customRenderers}
    />
  )
})
